export interface DataType {
  key: string;
  bpNumber: number;
  progression: number[];
  status: string;
  sku: string
}

export interface IBox {
  ON_GOING: boolean
  PENDING: boolean
  COMPLETE: boolean
  TO_DO: boolean
}

export interface IDates {
  start: Date | undefined,
  end: Date | undefined
}

export enum TYPE {
  BC = "Bracelets courts",
  BL = "Bracelets longs"
}

export interface IBracelet {
  SKU: string,
  type: TYPE,
  count: number,
  barCode: string
}

export enum STATUS {
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  ERROR = "ERROR"
}

export interface ISku {
  _id: { _str: string },
  name: string,
  description: string,
  hermesSKU: string
}

export interface IRejectedRate {
  _id: null,
  error: number,
  success: number
}

export interface ITray {
  SKU: string,
  bpId: number,
  OLPN: any,
  createdOn: Date,
  modifiedOn: Date,
  skuList: any[],
  status: STATUS,
  trayNumber: string,
  _id: string
}